import { useEffect, useState } from "react";
import { useRange } from "react-instantsearch-hooks-web";
import styles from './RangeSlider.module.scss';
import dynamic from "next/dynamic";
const ReactSlider = dynamic(() => import('react-slider'), { ssr: false });


export default function RangeSlider(props) {
  const { range, refine } = useRange(props);
  const [windowVisible, setWindowVisible] = useState(false); // to prevent rendering text server side
  
  const [min, setMin] = useState(range.min);
  const [max, setMax] = useState(range.max);

  const onChange = (values) => {
    setMin(values[0]);
    setMax(values[1]);
  };

  const onAfterChange = (values) => {
    refine(values);
  };

  useEffect(() => {
    setWindowVisible(true);
  }, []);

  return (
    <div className="range-slider">

        <ReactSlider
          className={styles.slider}
          thumbClassName={styles.thumb}
          trackClassName={styles.track}
          value={[min, max]}
          ariaLabel={['Lower thumb', 'Upper thumb']}
          ariaValuetext={state => `Thumb value ${state.valueNow}`}
          renderThumb={(props, state) => {
            // Destructure the `key` out of props and pass the other props manually
            const { key, ...restProps } = props;
            return (
              <div
                key={`thumb-${state.index}`}  // Add unique key for each thumb
                {...restProps}
              >
                {/* Custom content for thumb */}
              </div>
            );
          }}
          min={range.min}
          max={range.max}
          onChange={(values) => onChange(values)}
          onAfterChange={(values) => onAfterChange(values)} 
        />
        <div className="flex" style={{justifyContent:"space-between"}}>
        {windowVisible &&(
        props.attribute.includes("price") ? (
          <>
            <span>${min}</span><span>${max}</span>
          </>
        ) : (
          <>
            <span>{min}%</span><span>{max}%</span>
          </>
        ) )}
          </div>
 
    </div>
  );
}
